import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export const IntegrationDudaRoutes = {
  path: 'integrations/duda/getting-started',
  async getComponent () {
    const {
      default: IntegrationsDudaContainer
    } = await import(/* webpackChunkName: "integrations-container-duda" */ './containers/IntegrationsDudaContainer')
      .catch(handleChunkLoadError);
    return IntegrationsDudaContainer;
  },
  getData ({ context }) {
    return context.props;
  }
};

export const IntegrationWebflowRoutes = {
  path: 'integrations/webflow',
  async getComponent () {
    const {
      default: IntegrationsWebflowContainer
    } = await import(/* webpackChunkName: "integrations-container-webflow" */ './containers/IntegrationsWebflowContainer')
      .catch(handleChunkLoadError);
    return IntegrationsWebflowContainer;
  },
  getData ({ context }) {
    return context.props;
  }
};
